import api from './api';

// Empresa e filiais do CNPJ no banco suporte (GET /empresa, rota da API sem tenant)
export interface IEmpresaAcesso {
  raz: string;
  cnpj: string;
  filiais: string[];
}

export async function buscarEmpresa(cnpj: string): Promise<IEmpresaAcesso> {
  const response = await api.get('/empresa', { params: { cnpj: cnpj.replace(/\D/g, '') } });

  return {
    raz: response.data.raz ?? '',
    cnpj: response.data.cnpj ?? cnpj.replace(/\D/g, ''),
    filiais: Array.isArray(response.data.filiais) ? response.data.filiais : []
  };
}
